
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-645fe2df&scoped=true!less-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ForgotPass.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ForgotPass.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-645fe2df!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgotPass.vue"),
  /* scopeId */
  "data-v-645fe2df",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/user/NonVerified/ForgotPass.vue
// module id = 1368
// module chunks = 18